import { SOPNote } from '@hakimo-ui/hakimo/types';
import { Button } from '@hakimo-ui/shared/ui-base';
import { ClipboardDocumentIcon } from '@heroicons/react/24/outline';
import clsx from 'clsx';
import { useState } from 'react';
import { DraggableFloatingModal } from '../floating-modal/DraggableFloatingModal';
import CameraLabels from '../sop-manager/camera-labels/CameraLabels';
import { getZeroToleranceTextColor } from './utils';

interface Props {
  notes: SOPNote[];
  isZeroToleranceSite?: boolean;
}
export const SOPNotesAction = (props: Props) => {
  const { notes, isZeroToleranceSite } = props;
  const [isNotesModalOpen, setIsNotesModalOpen] = useState(false);

  const handleOpenNotesModal = () => {
    setIsNotesModalOpen(true);
  };
  const handleCloseNotesModal = () => {
    setIsNotesModalOpen(false);
  };

  return (
    <div>
      <Button
        variant="icon"
        onClick={handleOpenNotesModal}
        title="SOP Notes"
        className={clsx(isZeroToleranceSite && 'hover:!bg-white/20')}
      >
        <ClipboardDocumentIcon
          className={clsx(
            'h-5 w-5 stroke-2',
            getZeroToleranceTextColor(isZeroToleranceSite)
          )}
        />
      </Button>
      <DraggableFloatingModal
        isOpen={isNotesModalOpen}
        onClose={handleCloseNotesModal}
        title="SOP Notes"
      >
        <ul className="list-disc space-y-2">
          {notes.map((note, i) => (
            <li key={i} className="ml-4 list-item">
              <div className="[overflow-wrap:anywhere]">{note.text}</div>
              <CameraLabels cameras={note.cameras} />
            </li>
          ))}
        </ul>
      </DraggableFloatingModal>
    </div>
  );
};
